export default __webpack_public_path__ + "static/media/gallery_01.ccd026e6.jpg";